import combineValidators from '../combineValidators'
import leadingWhitespace from './leadingWhitespace'
import trailingWhitespace from './trailingWhitespace'
import empty from './empty'

const whitespaceValidators = [leadingWhitespace, trailingWhitespace, empty]
export default combineValidators(whitespaceValidators)
